"use client";

import clsx from "clsx";
import { NpsScore } from "@/types/nps";
import { Button } from "@/components/ui/button";

const NPS_SCORES: NpsScore[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

type NpsScoreSelectorProps = {
  selectedScore: NpsScore | null;
  disabled?: boolean;
  onSelectScore: (score: NpsScore) => void;
};

export default function NpsScoreSelector({
  selectedScore,
  disabled = false,
  onSelectScore,
}: NpsScoreSelectorProps) {
  return (
    <div className="grid grid-cols-6 gap-2 sm:grid-cols-11" role="radiogroup">
      {NPS_SCORES.map((score) => {
        const selected = selectedScore === score;

        return (
          <Button
            key={score}
            type="button"
            variant={selected ? "default" : "outline"}
            size="sm"
            aria-checked={selected}
            className={clsx(
              "h-10 rounded-full px-0",
              selected && "ring-2 ring-primary ring-offset-2"
            )}
            disabled={disabled}
            role="radio"
            onClick={() => onSelectScore(score)}
          >
            {score}
          </Button>
        );
      })}
    </div>
  );
}
